import { Reducer } from 'redux'
import Cookies from 'universal-cookie'
import _ from 'lodash'
import * as actions from './actions'
import { Theme, ThemeValidationResult, ThemeValidationParameters } from './types'

export const cookies = new Cookies()

export type ThemeState = Readonly<{
  themes: Record<string, Theme>
  isValidating: boolean
  isSaving: boolean
  validationResult: ThemeValidationResult | null
  selectedTheme: ThemeValidationParameters | null
}>

export const initState: ThemeState = {
  themes: {},
  isValidating: false,
  isSaving: false,
  validationResult: null,
  selectedTheme: null
}

// reducer
export const themeReducer: Reducer<ThemeState, actions.ThemeActions> = (state = initState, action) => {
  switch (action.type) {
    case actions.FETCH_THEME_SUCCESS:
      return {
        ...state,
        themes: { ..._.keyBy(action.payload, 'id') }
      }
    case actions.START_THEME_VALIDATION:
      return {
        ...state,
        isValidating: true
      }
    case actions.UPDATE_THEME_VALIDATION:
      return {
        ...state,
        validationResult: action.payload,
        isValidating: false
      }
    case actions.UPDATE_NEW_THEME:
      return {
        ...state,
        selectedTheme: action.payload.theme
      }
    case actions.RESET_NEW_THEME:
      return {
        ...state,
        selectedTheme: null
      }
    case actions.START_SAVING_THEME:
      return {
        ...state,
        isSaving: true
      }
    case actions.SAVING_THEME_SUCCESS:
      return {
        ...state,
        isSaving: false
      }
    case actions.FETCH_THEME_INFO:
      return {
        ...state,
        isLoading: true
      }
    case actions.FETCH_THEME_INFO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        selectedTheme: action.payload.theme
      }
    case actions.DELETING_THEME_FAIL:
      return {
        ...state,
        isLoading: false,
        selectedTheme: null
      }
    default:
      return state
  }
}
